import { Model } from "./model";

export class Incident extends Model {
    id: number;
    scenario_id: number;
    content: string;
    picture?: string;
}


// WEBPACK FOOTER //
// ./src/models/incident.model.ts